import React, { useEffect, useState, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { makeStyles } from '@material-ui/core/styles';
import SweetAlert from 'react-bootstrap-sweetalert';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsGetAll } from 'services/WService';

const useStyles = makeStyles(styles);

export default function ModalSeller(props) {
  const classes = useStyles();
  const seller = props.model;

  const [alert, setAlert] = useState(null);
  const [typeSeller, setTypeSeller] = useState('S');

  const messageResponse = (response) => {
    // Si el vendedor es de oficina, no mostrar usuario
    if(typeSeller === 'O'){
      return hideAlert();
    }

    if (!response.data.password) {
      return hideAlert();
    }
    setAlert(
      <SweetAlert
        style={{ display: 'block', marginTop: '-100px' }}
        title={`Usuario: ${response.data?.user.email} // Clave: ${response.data?.password}`}
        onConfirm={() => {
          hideAlert();
          props.reload();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
      />
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };

  const [zones, setZones] = useState([]);
  const [canals, setCanals] = useState([]);
  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listCanals() {
    let response = await wsGetAll('base/canal');
    if (response.success) setCanals(response.data);
  }

  useEffect(() => {
    if (seller.open) setTypeSeller(seller.seller_type || 'S');
  }, [seller.open]);

  useEffect(() => {
    if (typeSeller === 'O') {
      // Oficina
      listZones();
    } else if (typeSeller === 'S') {
      // Campo
      listCanals();
    }
  }, [typeSeller]);

  return (
    <Fragment>
      {alert}
      <Modal
        title="Vendedor"
        model={seller}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity="base/seller"
        responseData={messageResponse}
        state
        stateTitle="Estado SAP"
      >
        <TextField
          label="Nombre"
          fullWidth
          type="text"
          name="SlpName"
          margin="normal"
          defaultValue={seller?.SlpName || ''}
          required
        />
        <TextField
          label="DNI"
          fullWidth
          type="text"
          name="dni"
          margin="normal"
          defaultValue={seller?.dni || ''}
          onKeyPress={(e) => {
            var key = window.event ? e.which : e.keyCode;
            if (key < 48 || key > 57) {
              return e.preventDefault();
            }
          }}
          inputProps={{
            maxLength: 10,
            minLength: 8,
          }}
          required
        />
        <TextField
          label="Celular"
          fullWidth
          type="text"
          name="phone"
          margin="normal"
          onKeyPress={(e) => {
            var key = window.event ? e.which : e.keyCode;
            if (key < 48 || key > 57) {
              return e.preventDefault();
            }
          }}
          inputProps={{
            maxLength: 9,
            minLength: 9,
          }}
          defaultValue={seller?.phone || ''}
        />
        {seller.id ? undefined : (
          <>
            <FormControl fullWidth margin="normal" size="small" required>
              <InputLabel>Tipo Vededor</InputLabel>
              <Select
                defaultValue={seller.id ? seller.seller_type || '' : 'S'}
                inputProps={{
                  name: 'seller_type',
                }}
              >
                <MenuItem value="S" onClick={() => setTypeSeller('S')}>
                  Campo
                </MenuItem>
                <MenuItem value="O" onClick={() => setTypeSeller('O')}>
                  Oficina
                </MenuItem>
              </Select>
            </FormControl>
            {typeSeller === 'O' ? (
              <FormControl fullWidth margin="normal" size="small" required={typeSeller === 'O'}>
                <InputLabel>Zona</InputLabel>
                <Select
                  defaultValue={seller.base_zone_id || ''}
                  inputProps={{
                    name: 'base_zone_id',
                  }}
                >
                  {zones.map((zone, i) => {
                    return (
                      <MenuItem value={zone.id} key={i}>
                        {zone.description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            ) : undefined}
          </>
        )}
        {typeSeller === 'S' ? (
          <Fragment>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Multiples fuerzas de ventas</InputLabel>
              <Select
                defaultValue={seller.multiple_sale_forces || 'N'}
                inputProps={{
                  name: 'multiple_sale_forces',
                }}
              >
                <MenuItem value="Y">Si</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Canal</InputLabel>
              <Select
                defaultValue={seller.base_canal_id || ''}
                inputProps={{
                  name: 'base_canal_id',
                }}
              >
                {canals.map((canal, i) => {
                  return (
                    <MenuItem value={canal.id} key={i}>
                      {canal.description}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Login activo</InputLabel>
              <Select
                defaultValue={
                  seller?.login_active !== undefined
                    ? seller?.login_active === true
                      ? '1'
                      : '0'
                    : '1'
                }
                inputProps={{
                  name: 'login_active',
                }}
              >
                <MenuItem value="1">Si</MenuItem>
                <MenuItem value="0">No</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Validar gps</InputLabel>
              <Select
                defaultValue={seller.validate_gps || 'Y'}
                inputProps={{
                  name: 'validate_gps',
                }}
              >
                <MenuItem value="Y">Si</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </Select>
            </FormControl>
          </Fragment>
        ) : undefined}
      </Modal>
    </Fragment>
  );
}
